// @ts-nocheck
import React from 'react';
// import { renderRoutes } from 'react-router-config';
import { useRoutes, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import routes from './routes/routes';
import store from './utils/configureStore';
import { ModalProvider } from "@/components/modal/provider";
// The styled wrapper (components/ui/sonner), NOT bare sonner — it maps toast
// surfaces to the app tokens so toasts match the design system.
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from '@/auth/AuthProvider'
import { initAnalytics, initPageViewTracking } from '@/utils/analytics';

// GA4 conversion tracking — module scope so StrictMode double-mounts can't
// double-init. Both calls no-op everywhere except dash.staty.io.
initAnalytics();
initPageViewTracking(routes);

export default class Root extends React.Component {

  render() {
    return (
      <Provider store={store}>
        <AuthProvider>
          {/* One light Toaster — dark mode is disabled app-wide, so the old
              second dark <Toaster> could never show. */}
          <Toaster />
          <ModalProvider>
            {/* {useRoutes(routes)} */}
            <RouterProvider router={routes} />
          </ModalProvider>
        </AuthProvider>
      </Provider>
    );
  }
}